import React from 'react';
import Box from '@magalu/stereo-ui/atoms/Box';
import { currencyFormatter } from '@magalu/stereo-ui-utils';
import { shape, string, number, bool } from 'prop-types';
import { ProductShippingCost, Container } from './shipping-tags.styles';
import { ShippingDescription } from '../product-card.styles';
import TagInternational from '../../TagInternational';
import { isInternationalPrice } from '../../../utils';

const ProductCardShippingTag = ({
  showShippingTags,
  shippingTag,
  price
}) => {
  const {
    time,
    cost,
    complement
  } = shippingTag;
  const showTagInternational = isInternationalPrice(price);
  const costDescription = cost === 0 ? 'Frete grátis' : `Frete: ${currencyFormatter({
    value: cost
  })}`;

  const ShippingCost = () => {
    return cost === 0 ? /*#__PURE__*/React.createElement(ShippingDescription, null, costDescription) : /*#__PURE__*/React.createElement(ProductShippingCost, null, costDescription);
  };

  return /*#__PURE__*/React.createElement(Box, {
    marginTop: 1
  }, showTagInternational && /*#__PURE__*/React.createElement(TagInternational, null), showShippingTags && /*#__PURE__*/React.createElement(Container, {
    "data-testid": "productCard-shipping-tag"
  }, cost !== null && cost !== undefined && /*#__PURE__*/React.createElement(ShippingCost, null), time && /*#__PURE__*/React.createElement(ShippingDescription, null, time), complement && /*#__PURE__*/React.createElement(ShippingDescription, null, complement)));
};

process.env.NODE_ENV !== "production" ? ProductCardShippingTag.propTypes = {
  showShippingTags: bool,
  price: shape({
    currency: string
  }),
  shippingTag: shape({
    error: string,
    time: string,
    cost: number,
    complement: string
  })
} : void 0;
ProductCardShippingTag.defaultProps = {
  showShippingTags: false,
  shippingTag: {},
  price: {}
};
export default ProductCardShippingTag;